// extracted by mini-css-extract-plugin
module.exports = {"search":"SearchSection_search__HUPY5","search_enabled":"SearchSection_search_enabled__2R9s4","slotBG":"SearchSection_slotBG__V7I_Y"};